import React from 'react';

/**
 * Floating bottom-right nav arrows for the takeover wizard.
 *
 * Iter-6 (operator walk 2026-05-09): hoisted out of StepLayout so it
 * can sit as a sibling of `.step-transition` in App.jsx — not a
 * descendant. The step-transition keyframe applies `transform:
 * translateY(...)` with `animation-fill-mode: both`; any descendant
 * with `position: fixed` resolves its containing block against that
 * transformed ancestor, not the viewport, which made the arrows drift
 * to mid-content during step transitions. Sibling placement keeps the
 * fixed-positioning anchored to the viewport.
 *
 * Behavior:
 *   - up arrow: previous step. Enabled when App.jsx passes onBack —
 *     disabled on the Welcome step and the terminal Confirmation step.
 *   - down arrow: forward to a step the seller has already reached.
 *     Disabled when there's no forward step (seller is at the head
 *     of their progress) — so they can't skip past un-filled pages,
 *     only revisit already-completed ones after a back-nav.
 */
export default function TakeoverNav({ onBack, onForward }) {
  return (
    <div className="takeover-nav" aria-hidden="true">
      <button
        type="button"
        className="takeover-nav__btn"
        disabled={!onBack}
        aria-label="Previous step"
        tabIndex={onBack ? 0 : -1}
        onClick={onBack ? () => onBack() : undefined}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <polyline points="18 15 12 9 6 15" />
        </svg>
      </button>
      <button
        type="button"
        className="takeover-nav__btn"
        disabled={!onForward}
        aria-label="Next step"
        tabIndex={onForward ? 0 : -1}
        onClick={onForward ? () => onForward() : undefined}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
    </div>
  );
}
